import React from "react";

const Contact = () => {
return(
    <div className="h-screen dark:bg-gray-700 bg-gray-200 pt-12">
  {/* Card start */}
  <div className="max-w-sm mx-auto bg-white dark:bg-gray-900 rounded-lg overflow-hidden shadow-lg">
    <div className="border-b px-4 pb-6">
      <div className="text-center my-4">
        <img className="h-32 w-32 rounded-full border-4 border-white dark:border-gray-900 mx-auto my-4" src="https://scontent.fcgk43-1.fna.fbcdn.net/v/t39.30808-6/449843676_1988417588249189_1633993300480641435_n.jpg?stp=c0.58.526.526a_dst-jpg_p526x296&_nc_cat=105&ccb=1-7&_nc_sid=6ee11a&_nc_eui2=AeFyq1n4BHrubEquoaPH5JAWQzQ2EWyflj5DNDYRbJ-WPj-lI8dMsmy47SdwpnasNsv3vY9A4krD-UY4Up3qhqSR&_nc_ohc=bdHwtxZy_TUQ7kNvgHB3Xes&_nc_zt=23&_nc_ht=scontent.fcgk43-1.fna&_nc_gid=AZLi6SLBTU-Ypu3jEDdx0DQ&oh=00_AYAe6rl5ooEw2HY6Me25kyieEa__0GQPwcZWjs5l_nufXg&oe=6715BC85" alt="" />
        <div className="py-2">
          <h3 className="font-bold text-2xl text-gray-800 dark:text-white mb-1">Rayhan Gusmiran</h3>
          <div className="inline-flex text-gray-700 dark:text-gray-300 items-center">
            <svg className="h-5 w-5 text-gray-400 dark:text-gray-600 mr-1" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24}>
              <path className d="M5.64 16.36a9 9 0 1 1 12.72 0l-5.65 5.66a1 1 0 0 1-1.42 0l-5.65-5.66zm11.31-1.41a7 7 0 1 0-9.9 0L12 19.9l4.95-4.95zM12 14a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" />
            </svg>
            Jakarta Selatan
          </div>
        </div>
      </div>
      <div className="flex gap-2 px-2">
        <button className="flex-1 rounded-full bg-blue-600 dark:bg-blue-800 text-white dark:text-white antialiased font-bold hover:bg-blue-800 dark:hover:bg-blue-900 px-4 py-2">
        <a href="https://www.instagram.com/rgusmiran/" >
          Follow
            </a>
        </button>
        <button  className="flex-1 rounded-full border-2 border-gray-400 dark:border-gray-700 font-semibold text-black dark:text-white px-4 py-2">
            <a href="https://wa.me/6283806475203">
          Message
            </a>
        </button>
      </div>
    </div>
    <div id="third-party-auth" className="flex items-center justify-center mt-5 flex-wrap">
  <a href="mailto:rgusmiran@gmail.com" className="hover:scale-105 ease-in-out duration-300 shadow-lg p-2 rounded-lg m-1">
    <img className="max-w-[25px]" src="https://ucarecdn.com/8f25a2ba-bdcf-4ff1-b596-088f330416ef/" alt="Google" />
  </a>
  <a href="https://www.linkedin.com/in/rayhan-gusmiran/" target="_blank" rel="noopener noreferrer" className="hover:scale-105 ease-in-out duration-300 shadow-lg p-2 rounded-lg m-1">
    <img className="max-w-[25px]" src="https://ucarecdn.com/95eebb9c-85cf-4d12-942f-3c40d7044dc6/" alt="LinkedIn" />
  </a>
  <a href="https://github.com/rayhan-gusmiran/" target="_blank" rel="noopener noreferrer" className="hover:scale-105 ease-in-out duration-300 shadow-lg p-2 rounded-lg m-1">
    <img className="max-w-[25px] filter dark:invert" src="https://ucarecdn.com/be5b0ffd-85e8-4639-83a6-5162dfa15a16/" alt="GitHub" />
  </a>
  <a href="https://www.facebook.com/rayhan.gusmiran.3" target="_blank" rel="noopener noreferrer" className="hover:scale-105 ease-in-out duration-300 shadow-lg p-2 rounded-lg m-1">
    <img className="max-w-[25px]" src="https://ucarecdn.com/6f56c0f1-c9c0-4d72-b44d-51a79ff38ea9/" alt="Facebook" />
  </a>
  <a href="https://www.instagram.com/rgusmiran/" target="_blank" rel="noopener noreferrer" className="hover:scale-105 ease-in-out duration-300 shadow-lg p-2 rounded-lg m-1">
    <img className="max-w-[25px] dark:gray-100" src="https://seeklogo.com/images/I/instagram-new-2016-logo-D9D42A0AD4-seeklogo.com.png" alt="Instagram" />
  </a>
</div>


   
  </div>
</div>


)
}

export default Contact;